import { useEffect, useState } from 'react';
import { getUserStats } from './DbServices';
import { getStoredUser } from '../utilities/encryption';

export default function StatsCards() {
  const [stats, setStats] = useState({
    plan_name: 'Loading...',
    messages_sent: 0,
    message_limit: 0,
    devices_used: 0,
    device_limit: 0,
    is_connected: false
  });
  const [loading, setLoading] = useState(true);


  const user = getStoredUser();


  const userId = user.data.id;

  useEffect(() => {
    const fetchStats = async () => {
      
      const res = await getUserStats(userId);
      
      if (res && res.status === 200) {
        setStats(res.data);
      }
      setLoading(false);
    };

    if (userId) {
      fetchStats();
    }
  }, [userId]);

  if (loading) {
    return (
      <div className="row mb-4">
        {[1, 2, 3, 4].map((i) => (
          <div className="col-md-3 mb-3" key={i}>
            <div className="card border-0 shadow-sm rounded-3 p-4 text-center">
              <div className="spinner-border spinner-border-sm text-primary"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="row mb-4">
      <Card 
        title="Active Plan" 
        value={stats.plan_name} 
        icon="fas fa-crown text-warning" 
      />
      <Card 
        title="Messages Used" 
        value={`${stats.messages_sent} / ${stats.message_limit}`} 
        icon="fas fa-paper-plane text-primary" 
      />
      <Card 
        title="Active Devices" 
        value={`${stats.devices_used} / ${stats.device_limit}`} 
        icon="fas fa-mobile-alt text-info" 
      />
      <Card 
        title="WhatsApp Status" 
        value={stats.is_connected ? "Connected" : "Disconnected"} 
        icon={`fas fa-circle ${stats.is_connected ? 'text-success' : 'text-danger'}`} 
      />
    </div>
  );
}

function Card({ title, value, icon }) {
  return (
    <div className="col-md-3 mb-3">
      <div className="card border-0 shadow-sm rounded-3 transition-hover">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="text-muted mb-0 small text-uppercase fw-bold">{title}</p>
            <i className={icon}></i>
          </div>
          <h4 className="fw-bold mb-0">{value}</h4>
        </div>
      </div>
    </div>
  );
}